export default function NotificationsScreen() {
  return null;
}
